import { render, staticRenderFns } from "./cardImage.vue?vue&type=template&id=07adb51c&scoped=true&"
import script from "./cardImage.vue?vue&type=script&lang=js&"
export * from "./cardImage.vue?vue&type=script&lang=js&"
import style0 from "./cardImage.vue?vue&type=style&index=0&id=07adb51c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07adb51c",
  null
  
)

export default component.exports